export default {
  MEDIA_CORNERS_GIF: './images/website-design/media-corners.gif',
  COLUMN_CORNERS_GIF: './images/website-design/column-corners.gif',
  PRIMARY_FONT_GIF: './images/website-design/primary-font.gif',
  SECONDARY_FONT_GIF: './images/website-design/secondary-font.gif',
};
